<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="page_ttl">
          <h1 class="h1">
            <span>회원가입</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">아이디</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input type="text" placeholder="아이디를 입력해 주세요" v-model="form.userId">
                      </div>
                      <button class="btn bo" @click="fnCheckId">중복 확인</button>
                    </div>
                    <p class="valid on" style="color: blue;" ><span style="color: blue;" >* 6~20자 영문 대/소문자, 숫자만 사용가능합니다</span></p><!--'on 추가'-->
                    <p class="valid on" v-show="$v.form.userId.$error">{{ msg.userId }}</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">비밀번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="password" placeholder="비밀번호를 입력해 주세요" v-model="form.userPw">
                      <!-- 비밀번호 유효성 문구 변경 및 기능 변경 (서남아이에스 임현아, 2024-09-06) -->
                      <!-- <p class="valid on" style="color: blue;" ><span style="color: blue;" >* 6~20자 영문 대/소문자, 숫자, 특수문자만 사용가능합니다</span></p>'on 추가' -->
                      <p class="valid on" style="color: blue;" ><span style="color: blue;" >* 8~20자 영문 대/소문자, 숫자, 특수문자를 조합해야만 사용 가능합니다</span></p><!--'on 추가'-->
                      <p class="valid on" v-show="$v.form.userPw.$error"> {{ msg.userPw }}</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">비밀번호 확인</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="password" placeholder="다시 한 번 입력해 주세요"  v-model="form.userPw2">
                      <p class="valid on" v-show="$v.form.userPw2.$error">{{ msg.userPw2 }}</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p >휴대폰 번호</p>
                  </div>
                  <div class="form_in" v-show="!$Util.isEmpty(user.userPhone)">
                    <p class="bind">{{ user.userPhone }}</p>
                  </div>
                  <div class="form_in" v-show="$Util.isEmpty(user.userPhone)">
                    <div class="input">
                      <input type="text" placeholder="-를 제외하고 입력해 주세요" v-model="form.userPhone"
                             oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');">
                      <p class="valid on" v-show="$v.form.userPhone.$error">휴대폰 번호를 입력해주세요.</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>이름</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ user.name }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>생년월일</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ user.birth }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">이메일</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="text" placeholder="이메일을 입력해 주세요"  v-model="form.email">
                      <p class="valid on" v-show="$v.form.email.$error">{{ msg.email }}</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>전화 번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="number" placeholder="-를 제외하고 입력해 주세요" v-model="form.companyPhone">
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">주소</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input type="number" placeholder="우편 번호" disabled v-model="form.postalCode">
                      </div>
                      <button class="btn bo" @click="
                          $store.commit('layout/setModalAlert', {
                            modalAlertName:
                              $modalAlertNames.MODAL_DAUM_POST_CODE,
                            callBack: fnBind
                          })
                        ">주소 검색</button>
                    </div>
                    <div class="input">
                      <input type="text" placeholder="주소를 입력해 주세요" disabled v-model="form.address">
                    </div>
                    <div class="input">
                      <input type="text" placeholder="상세주소를 입력해 주세요" v-model="form.address2">
                    </div>
                    <p class="valid on" v-show="$v.form.address.$error">주소를 입력해주세요.</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>수신동의</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="checkbox">
                        <input type="checkbox" id="d" :true-value="1" :false-value="2" v-model="form.isSms"><!--디폴트: 체크된 상태-->
                        <label for="d"><span>SMS</span></label>
                      </div>
                      <div class="checkbox">
                        <input type="checkbox" id="e" :true-value="1" :false-value="2" v-model="form.isEmail">
                        <label for="e"><span>이메일</span></label>
                      </div>
                      <!-- 수신동의 : 전화추가 (서남아이에스 임현아, 2024-05-24) -->
                      <div class="checkbox">
                        <input type="checkbox" id="p" :true-value="1" :false-value="2" v-model="form.isPhone">
                        <label for="p"><span>전화</span></label>
                      </div>
                      <!-- 수신동의 : 전화추가 끝 -->
                    </div>
                    <p class="valid">유효성 문구 영역</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li top_bo">
                  <div class="check_list">
                    <ul class="check_list_ul w600">
                      <li class="check_list_li">
                        <div class="checkbox">
                          <input type="checkbox" id="a" :true-value="1" :false-value="2" v-model="form.isPrivacy">
                          <label for="a"><span class="essen">개인정보 처리 방침에 동의합니다</span></label>
                          <p class="valid on" v-show="$v.form.isPrivacy.$error">필수 입니다.</p><!--'on 추가'-->
                        </div>
                        <button class="btn bo grey" @click="fnView(1)">내용보기</button>
                      </li>
                      <li class="check_list_li">
                        <div class="checkbox">
                          <input type="checkbox" id="b" v-model="form.isTerms" :true-value="1" :false-value="2">
                          <label for="b"><span class="essen">이용약관에 동의합니다</span></label>
                          <p class="valid on" v-show="$v.form.isTerms.$error">필수 입니다.</p><!--'on 추가'-->
                        </div>
                        <button class="btn bo grey" @click="fnView(2)">내용보기</button>
                      </li>
                      <li class="check_list_li">
                        <div class="checkbox">
                          <input type="checkbox" id="c" v-model="form.isMarketing" :true-value="1" :false-value="2">
                          <label for="c"><span>제 3자 마케팅 동의</span></label>
                        </div>
                        <button class="btn bo grey" @click="fnView(3)">내용보기</button>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="fnSave">회원가입</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import Util from '@/common/utils/Util'
const isIdValid = (value) => (Util.isIdValid(value))
const isTrimValid = (value) => (Util.isTrimValid(value))
export default {
  name: 'sign-up-step2-index',
  mounted() {
      // gtag.js 스크립트 동적 삽입
      const gtagScript = document.createElement('script');
      gtagScript.setAttribute('async', '');
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17027951128';
      document.head.appendChild(gtagScript);

      // gtag 초기화
      gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', 'AW-17027951128');
      }
  },
  description: '회원가입 폼',
  data: function () {
    return {
      user: {
        name: this.$route.query.name,
        userPhone: this.$route.query.userPhone,
        birth: this.$route.query.birth,
        authCode: this.$route.query.authType
      },
      checkId: false,
      form: {
        address: '',
        address2: '',
        birth: '',
        companyPhone: '',
        email: '',
        isAuth: 1,
        isEmail: 2,
        isPhone: 2, //수신동의 : 전화추가 (서남아이에스 임현아, 2024-05-24)
        isSms: 1,
        name: '',
        userId: '',
        userNo: -1,
        userPhone: '',
        userPw: '',
        userType: 1,
        postalCode: '',
        userPw2: '',
        isPrivacy: 2,
        isTerms: 2,
        isMarketing: 2
      },
      msg: {
        address: '',
        address2: '',
        birth: '',
        companyPhone: '',
        email: 0,
        name: '',
        userId: '',
        userPhone: '',
        userPw2: '',
        userPw: '',
        userType: 1,
        isPrivacy: 0,
        isTerms: 0,
        isMarketing: 0
      }
    }
  },
  methods: {
    fnCheckId: async function() {
      if (this.$Util.isEmpty(this.form.userId)) return false
      const params = {}
      params.userId = this.form.userId
      if(!this.$Util.isIdValid(this.form.userId)) {
        this.checkId = false
        alert('올바르지 않은 아이디 형식입니다.')
        return false
      }
      const res = await this.$SignSvc.duplicationId(params)
      if (res.code === 1) {
        this.checkId = true
        alert('사용가능한 아이디 입니다.')
        return false
      } else {
        this.checkId = false
        alert(res.message)
      }
    },
    fnBind: function ({roadAddress, zonecode}) {
      this.form.address = roadAddress
      this.form.postalCode = zonecode
    },
    fnSave: async function () {
      // 회원가입, 알럿 추가 (서남아이에스 임현아, 2024-11-18)
      if (!this.$Util.isValid(this.$v, this.$el))

      // 데이터 필수값 체크
      if (this.$Util.isEmpty(this.form.userId)) {
        alert("아이디를 입력해주세요.");
        return false
      }

      if (this.checkId === false) {
        alert("아이디를 중복 확인해주시기 바랍니다.");
        return false
      }

      const isValid = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/.test(this.form.userPw);
      if (this.$Util.isEmpty(this.form.userPw) || !isValid || this.$Util.isEmpty(this.form.userPw2) || (this.form.userPw !== this.form.userPw2)) {
        alert("비밀번호를 확인해주시기 바랍니다.");
        return false
      }

      if (this.$Util.isEmpty(this.form.email) || this.$Util.isEmpty(this.form.address)) {
        alert("이메일, 혹은 주소를 확인해주시기 바랍니다.");
        return false
      }

      // this.$v.$touch()
      let params = {}
      params = this.$_.merge({}, this.form, this.user)
      if (this.$Util.isEmpty(this.user.userPhone)) {
        params.userPhone = this.form.userPhone
      }
      params.authCode = this.$ConstCode.USER_KCB__AUTH_TYPE[this.user.authCode].value
      console.log('params:::', params)
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      const res = await this.$SignSvc.join(params)
      if (res.code === 1) {
        alert('회원가입되었습니다.')
        // 회원가입 완료시 페이지 이동 변경 (서남아이에스 임현아, 2024-11-18)
        // this.$router.push({
        //   path: '/main'
        // })
        window.location.href = "https://www.kfoodedu.or.kr/";
      } else {
        alert(res.message)
      }
    },
    fnView: function(type = 1) {
      if(type === 1) {
        this.$store.commit('layout/setModalAlert', {
          modalAlertName: this.$modalAlertNames.MODAL_INFO_PRIVACY_POLICY,
          callBack: this.form.isPrivacy = 1
        })
      } else if(type === 2){
        this.$store.commit('layout/setModalAlert', {
          modalAlertName: this.$modalAlertNames.MODAL_INFO_TERMS,
          callBack: this.form.isTerms = 1
        })
      } else if(type === 3) {
        this.$store.commit('layout/setModalAlert', {
          modalAlertName: this.$modalAlertNames.MODAL_MARKETING,
          callBack: this.form.isMarketing = 1
        })
      }

    }
  },
  validations: {
    form: {
      userId: {
        test: function(val) {
          if (val.checkId === false) {
            this.msg.userId = '중복 확인을 해주세요.'
            return false
          }
          if (!required(val)) {
            this.msg.userId = '아이디를 입력해주세요.'
            return false
          }
          if (!isIdValid(val)) {
            this.msg.userId = '올바르지 않은 아이디 형식입니다.'
            return false
          }
          return true
        }
      },
      userPw: {
        valid(val) {
          this.msg.userPw = ''
          // if (val.length < 6) {
          //   this.msg.userPw = '숫자 6자 이상 입력해주세요.'
          //   return false
          // }
          // 비밀번호 유효성 문구 변경 및 기능 변경 (서남아이에스 임현아, 2024-09-06)
          const isValid = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/.test(val);
          if (!isValid){
            console.log(isValid)
            this.msg.userPw = '올바르지 않은 비밀번호 형식입니다.'
            return false
          } else {
            return required(val)
          }
        }
      },
      userPw2: {
        valid(val, obj) {
          this.msg.userPw2 = ''
          // if (val.length < 6) {
          //   this.msg.userPw = '숫자 6자 이상 입력해주세요.'
          //   return false
          // }
          if (obj.userPw !== val) {
            this.msg.userPw2 = '위의 비밀번호와 동일하게 입력해주세요'
            return false
          }
          return required(val)
        }
      },
      email: {
        test: function(val) {
          if (this.$Util.isEmpty(val)) {
            this.msg.email = '이메일을 입력해주세요.'
            return false
          }
          if (!isTrimValid(val)) {
            this.msg.email = '공백을 제거해주세요.'
            return false
          }
          return true
        }
      },
      address: {
        required
      },
      isPrivacy: {
        test: function(val) {
          if (val <= 0) {
            return false
          }
          return true
        }
      },
      isTerms: {
        test: function(val) {
          if (val <= 0) {
            return false
          }
          return true
        }
      },
      userPhone: {
        test: function(val) {
          if (!this.$Util.isEmpty(this.user.userPhone)) {
            return true
          } else {
            return required(val)
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
